<template>
  <div id="phone">
    <MazPhoneNumberInput
      v-model="phoneNumber"
      @update="setPayload"
      @clear="clearPhone"
      :class="{ 'border-bottom-blue': this.payload && this.payload.isValid }"
      class="pb-2"
      ref="input"
      :preferred-countries="['FR', 'BE', 'DE', 'GB', 'CA', 'US']"
      default-country-code="FR"
      :translations="{
        countrySelectorLabel: 'Code pays',
        countrySelectorError: 'Choisir un pays',
        phoneNumberLabel: 'Numéro de téléphone',
        example: 'Exemple :',
      }"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import Spinner from "vue-simple-spinner";
import { MazPhoneNumberInput } from "maz-ui";

export default {
  components: {
    Spinner,
    MazPhoneNumberInput,
  },
  data() {
    return {
      payload: null,
      phone: null,
    };
  },
  computed: {
    phoneNumber: {
      get() {
        return this.$store.state.userData.phone;
      },
      set() {
        if (this.payload.e164) {
          this.$store.commit("SET_PHONE", this.payload.e164);
        } else {
          this.$store.commit("SET_PHONE", null);
        }
      },
    },
    ...mapState(["isPhoneValid", "isUserLoaded"]),
  },
  methods: {
    setPayload(payload) {
      this.payload = payload;
      this.$store.commit("SET_IS_PHONE_VALID", payload.isValid);
    },
    clearPhone() {
      this.payload = null;
    },
    focus() {
      document.querySelector(".maz-input__input").focus();
    },
  },
  mounted() {
    if (this.$router.currentRoute.name != "dashboard") this.focus();
  },
};
</script>

<style lang="scss" scoped>
#phone {
  @include media-breakpoint-up(md) {
    width: 21rem;
  }
}
::v-deep {
  input {
    border: none !important;
    box-shadow: none !important;
  }
  .maz-input__label,
  .country-selector__label,
  .maz-input.is-valid .maz-input__label {
    color: $body-text !important;
  }
  .maz-input.is-valid .maz-input__icon path.arrow {
    fill: $primary;
  }
  .maz-input__input {
    font-size: 1rem;
    font-weight: 600;
    color: $primary;
  }
  .country-selector__list {
    box-shadow: $box-shadow !important;
  }
  .maz-phone-number-input .country-selector {
    width: 8rem;
    flex: unset;
    min-width: unset;
    max-width: unset;
  }
}
</style>
